import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'oa-todo-list',
  name: '我的待办',
  icon: '待',
  group: 'OA 组件',
  description: '展示当前用户待处理的审批任务。',
  defaultProps: {
    title: '我的待办',
    limit: 5
}
}
